import { useTranslation } from 'react-i18next';

export default function SafetySection() {
  const { t } = useTranslation();

  const items = [
    { icon: 'ri-user-search-line', titleKey: 'safety_seller_title', descKey: 'safety_seller_desc' },
    { icon: 'ri-camera-line', titleKey: 'safety_qc_title', descKey: 'safety_qc_desc' },
    { icon: 'ri-links-line', titleKey: 'safety_link_title', descKey: 'safety_link_desc' },
    { icon: 'ri-secure-payment-line', titleKey: 'safety_payment_title', descKey: 'safety_payment_desc' },
    { icon: 'ri-truck-line', titleKey: 'safety_shipping_title', descKey: 'safety_shipping_desc' },
    { icon: 'ri-refund-line', titleKey: 'safety_refund_title', descKey: 'safety_refund_desc' },
  ];

  return (
    <section id="safety" className="w-full bg-background-50 py-16 md:py-24">
      <div className="section-container">
        <div className="section-inner">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            <div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-5 font-heading">
                {t('safety_title')}
              </h2>
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed">
                {t('safety_desc')}
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {items.map((item) => (
                <div
                  key={item.titleKey}
                  className="p-5 rounded-lg bg-background-100 border border-background-200/70 hover:border-secondary-300 transition-all"
                >
                  <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center mb-3">
                    <i className={`${item.icon} text-lg text-secondary-600`} />
                  </div>
                  <h3 className="font-semibold text-foreground-950 mb-1 text-sm">
                    {t(item.titleKey)}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {t(item.descKey)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}